/* bc: kart görsel noktaları — koleksiyon/arama ızgarasındaki ürün kartlarında
   görsel sayısını gösteren nokta şeridi (referans: kitikate.com.tr .owl-dots).
   Horizon'un slideshow'unda nokta göstergesi yok, yalnız ok var; oklar CSS ile
   gizlendi ve yerine bu şerit basılıyor. Stiller theme.liquid → bc-start: kart-kitikate. */

const SECICI = '.product-grid .card-gallery';

function kur(galeri) {
  if (galeri.dataset.bcDots) return;

  const bilesen = galeri.querySelector('slideshow-component');
  if (!bilesen) return;

  const slaytlar = [...bilesen.querySelectorAll('slideshow-slide:not([hidden])')];
  if (slaytlar.length < 2) return;

  galeri.dataset.bcDots = '1';

  const serit = document.createElement('div');
  serit.className = 'bc-card-dots';

  slaytlar.forEach((slayt, i) => {
    const nokta = document.createElement('button');
    nokta.type = 'button';
    nokta.className = 'bc-card-dots__dot';
    nokta.setAttribute('aria-label', i + 1 + '. görsel');
    nokta.addEventListener('click', (e) => {
      // Kart tamamen bir <a> ile kaplı — tıklama yukarı gitmemeli.
      e.preventDefault();
      e.stopPropagation();
      if (typeof bilesen.select === 'function') {
        try {
          bilesen.select(i);
          return;
        } catch (_) {
          /* aşağıdaki kaydırmaya düş */
        }
      }
      const kaydirici = bilesen.querySelector('slideshow-slides');
      if (kaydirici) kaydirici.scrollTo({ left: slayt.offsetLeft, behavior: 'smooth' });
    });
    serit.appendChild(nokta);
  });

  galeri.appendChild(serit);

  const guncelle = () => {
    let aktif = slaytlar.findIndex((s) => s.getAttribute('aria-hidden') === 'false');
    if (aktif < 0) aktif = 0;
    [...serit.children].forEach((d, i) => d.classList.toggle('is-active', i === aktif));
  };

  guncelle();

  // Slayt değişimi aria-hidden üzerinden okunuyor (hover ön izlemesi de buradan geçiyor).
  const gozcu = new MutationObserver(guncelle);
  slaytlar.forEach((s) => gozcu.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] }));
}

function tara() {
  document.querySelectorAll(SECICI).forEach(kur);
}

tara();

// Filtre / sıralama / sonsuz sayfalama bölümü yeniden basıyor.
let zamanlayici = null;
new MutationObserver(() => {
  clearTimeout(zamanlayici);
  zamanlayici = setTimeout(tara, 120);
}).observe(document.documentElement, { childList: true, subtree: true });
